import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  DeletePromptMutation,
  DeletePromptMutationVariables,
} from '#/graphql/generated';

export const DELETE_PROMPT: TypedDocumentNode<
  DeletePromptMutation,
  DeletePromptMutationVariables
> = gql`
  mutation DeletePrompt($input: DeletePromptInput!) {
    deletePrompt(input: $input) {
      message
      success
    }
  }
`;
